import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = {
  key: 0,
  class: "fa-regular fa-search"
}
const _hoisted_3 = { class: "filter-group__dropdown" }
const _hoisted_4 = {
  key: 0,
  class: "filter-group__count fw-bold"
}
const _hoisted_5 = { class: "filter-group__checkboxes" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "filter-group__dropdown" }
const _hoisted_9 = {
  key: 0,
  class: "filter-group__count fw-bold"
}
const _hoisted_10 = { class: "filter-group__checkboxes" }
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = ["for"]
const _hoisted_13 = {
  key: 0,
  type: "submit",
  class: "btn btn-primary submit-btn"
}
const _hoisted_14 = {
  key: 1,
  class: "js-selected-tags"
}
const _hoisted_15 = ["onClick"]

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useProgramStore } from '@ProgramList/stores/programStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgramFilters',
  props: {
    live: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const interests = ref<string[]>([]);
const types = ref<string[]>([]);

const props = __props;

const store = useProgramStore();
const {
	keyword: storeKeyword,
	interests: storeInterests,
	types: storeTypes
} = storeToRefs(store);

// Local state for non-live mode
const localKeyword = ref('');
const localInterests = ref<string[]>([]);
const localTypes = ref<string[]>([]);

// Bound computed values
const keywordsTyped = computed({
	get: () => props.live ? storeKeyword.value : localKeyword.value,
	set: val => props.live ? storeKeyword.value = val : localKeyword.value = val
});
const selectedInterests = computed({
	get: () => props.live ? storeInterests.value : localInterests.value,
	set: val => props.live ? storeInterests.value = val : localInterests.value = val
});
const selectedTypes = computed({
	get: () => props.live ? storeTypes.value : localTypes.value,
	set: val => props.live ? storeTypes.value = val : localTypes.value = val
});

const route = useRoute();
const router = useRouter();

function updateQueryParams() {
    const query = {
        keyword: keywordsTyped.value || '',
        interests: selectedInterests.value.join(','),
        types: selectedTypes.value.join(','),
    };

    router.push({ path: route.path, query });
}

// If in live mode (majors & programs page only), watch for changes and update the store filters
if (props.live) {
	watch([keywordsTyped, selectedInterests, selectedTypes], ([k, i, t]) => {
		store.setFilters({ keyword: k, interests: i, types: t });
        updateQueryParams();
	});
}

// values sent as query parameters to the main app page
const emit = __emit;

const handleSubmit = () => {
	const payload = {
		keyword: localKeyword.value,
		interests: localInterests.value,
		types: localTypes.value,
	};
	emit('submit', payload);
};

// Pill values (combined list)
const selectedFilters = computed(() => [...selectedInterests.value, ...selectedTypes.value]);

// Check to see if there is a least one selected checkbox
const hasSelections = computed(() => {
    return keywordsTyped.value.length > 0 || selectedInterests.value.length > 0 || selectedTypes.value.length > 0;
});

// Remove individual filter
const removeFilter = (value: string) => {
    selectedInterests.value = selectedInterests.value.filter(v => v !== value);
    selectedTypes.value = selectedTypes.value.filter(v => v !== value);
};

// Clear all filters
const clearAllFilters = () => {
    keywordsTyped.value = '';
    selectedInterests.value = [];
    selectedTypes.value = [];
    updateQueryParams();
};

const openDropdown = ref<'interests' | 'types' | null>(null);

// toggle filter dropdowns
function toggleDropdown(type: 'interests' | 'types') {
    openDropdown.value = openDropdown.value === type ? null : type;
}

function closeDropdownsOnClickOutside(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.closest('.js-filter-group')) {
        openDropdown.value = null;
    }
}

onMounted(() => {
    document.addEventListener('click', closeDropdownsOnClickOutside);

    const appEl = document.querySelector<HTMLElement>('#app[data-interests-path]');
    const jsonPath = appEl?.getAttribute('data-interests-path');

    (async () => {
        const appEl = document.querySelector<HTMLElement>('#app[data-interests-path]');
        const jsonPath = appEl?.getAttribute('data-interests-path');

        if (jsonPath) {
            try {
                const response = await fetch(jsonPath);
                if (!response.ok) throw new Error('Failed to fetch JSON');

                const data = await response.json();
                interests.value = Array.isArray(data.interests) ? data.interests : [];
                types.value = Array.isArray(data.types) ? data.types : [];
            } catch (error) {
                console.error('Error loading interests/types:', error);
            }
        }
    })();
});

onUnmounted(() => {
    document.removeEventListener('click', closeDropdownsOnClickOutside);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
    class: "form",
    target: "_top"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("label", {
        for: "keyword",
        class: "form-label visually-hidden"
      }, "Keyword", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keywordsTyped).value = $event)),
        class: _normalizeClass(["form-control", { 'is-live-keywords': _ctx.live }]),
        id: "keyword",
        placeholder: "Search by keyword"
      }, null, 2 /* CLASS */), [
        [_vModelText, keywordsTyped.value]
      ]),
      (_ctx.live)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Filter by Interest "),
    _createElementVNode("div", {
      class: _normalizeClass(["filter-group js-filter-group", { open: openDropdown.value === 'interests' }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn filter-group__button js-dropdown-btn",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleDropdown('interests')))
        }, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "me-1 fw-bold" }, "Filter by Interest", -1 /* CACHED */)),
            (selectedInterests.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(selectedInterests.value.length) + ") ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "filter-group__icon" }, [
            _createElementVNode("i", { class: "fa-regular fa-angle-down" })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["filter-group__menu js-dropdown-menu", { active: openDropdown.value === 'interests' }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interests.value, (interest) => {
              return (_openBlock(), _createElementBlock("div", {
                key: interest,
                class: "form-check"
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `interest-${interest}`,
                  value: interest,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedInterests).value = $event))
                }, null, 8 /* PROPS */, _hoisted_6), [
                  [_vModelCheckbox, selectedInterests.value]
                ]),
                _createElementVNode("label", {
                  for: `interest-${interest}`,
                  class: "form-check-label"
                }, _toDisplayString(interest), 9 /* TEXT, PROPS */, _hoisted_7)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */)
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" Filter by Type "),
    _createElementVNode("div", {
      class: _normalizeClass(["filter-group js-filter-group", { open: openDropdown.value === 'types' }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn filter-group__button js-dropdown-btn",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleDropdown('types')))
        }, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "me-1 fw-bold" }, "Filter by Program Type", -1 /* CACHED */)),
            (selectedTypes.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(selectedTypes.value.length) + ") ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "filter-group__icon" }, [
            _createElementVNode("i", { class: "fa-regular fa-angle-down" })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["filter-group__menu js-dropdown-menu", { active: openDropdown.value === 'types' }])
        }, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (type) => {
              return (_openBlock(), _createElementBlock("div", {
                key: type,
                class: "form-check"
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: type,
                  value: type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedTypes).value = $event))
                }, null, 8 /* PROPS */, _hoisted_11), [
                  [_vModelCheckbox, selectedTypes.value]
                ]),
                _createElementVNode("label", {
                  for: type,
                  class: "form-check-label"
                }, _toDisplayString(type), 9 /* TEXT, PROPS */, _hoisted_12)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */)
      ])
    ], 2 /* CLASS */),
    (!_ctx.live)
      ? (_openBlock(), _createElementBlock("button", _hoisted_13, "Submit"))
      : _createCommentVNode("v-if", true),
    (hasSelections.value && _ctx.live)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFilters.value, (filter) => {
            return (_openBlock(), _createElementBlock("span", {
              key: filter,
              class: "filter-group__pill"
            }, [
              _createTextVNode(_toDisplayString(filter) + " ", 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                class: "filter-group__pill-remove",
                "aria-label": "Remove",
                onClick: ($event: any) => (removeFilter(filter))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fa-solid fa-xmark-large" }, null, -1 /* CACHED */)
              ]), 8 /* PROPS */, _hoisted_15)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(clearAllFilters, ["prevent"]),
            class: "js-clear-all filter-group__clear"
          }, "Clear All")
        ]))
      : _createCommentVNode("v-if", true)
  ], 32 /* NEED_HYDRATION */))
}
}

})